export default "__VITE_ASSET__C1_mc2Uw__"